import React, { useState } from "react"
import styled from "styled-components"
import breakpoints from "../../../styles/breakpoints"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import { withTranslation } from "gatsby-plugin-react-i18next"
import FilterOverlay from "./FilterOverlay"
import { Link } from "gatsby"
import { useBannerContext } from "../../../context/BannerContext"
import {
  getBespokeLink,
  getEngagementPlpLink,
  getWeddingLink,
} from "../../../services/links"
import { getIsFrance } from "../../../services/locale"
import { useLocation } from "@reach/router"

const MobileFilter = styled.div`
  background: ${colors.beige};
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: sticky;
  top: ${(props) => (props.$bannerH ? `${props.$bannerH + 44}px` : "44px")};
  z-index: 99;

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const Filter = styled.div`
  ${fonts.ivyStyleRegular};
  font-weight: 400;
  font-size: 12px;
  line-height: 1;
  text-transform: lowercase;
  padding: 12px 8px 12px 15px;
  border-top: 1px solid #cacaca;
  border-bottom: 1px solid #cacaca;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  position: relative;

  &:first-of-type {
    border-right: 1px solid #cacaca;
  }
`

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  span {
    width: 10px;
    height: 1px;
    background: ${colors.black};
    position: absolute;
    right: 0px;
    &:first-of-type {
    }

    &:last-of-type {
      transform: rotate(90deg);
      opacity: ${(props) => (props.$open ? 0 : 1)};
    }
  }
`

const CategoryOptions = styled.nav`
  position: absolute;
  top: calc(100% + 1px);
  left: 0;
  width: 100%;
  z-index: 1;
  background: ${colors.white};
  max-height: ${(props) => (props.$open ? "100vh" : "0")};
  overflow: hidden;
  transition: all 0.2s ease;

  ul {
    border-right: 1px solid #cacaca;
    border-bottom: 1px solid #cacaca;
    padding: 9px 0;
  }

  a {
    padding: 4px 15px;
    display: block;
    color: inherit;
    text-decoration: none;

    &:hover {
      background: ${colors.green};
      color: ${colors.white};
    }
  }
`

const LinkContainer = styled.li`
  color: ${(props) => (props.$isActive ? colors.lightGreen : colors.black)};
`

const MobileFilters = (props) => {
  const {
    t,
    filterOptions,
    applyFilter,
    setSort,
    handleColour,
    handlePrice,
    handleTypeFilter,
    handleStyle,
    colours,
    sort,
    price,
    types,
    styles,
    clearFilter,
  } = props
  const [sortOpen, setSortOpen] = useState(false)
  const [categoryOpen, setCategoryOpen] = useState(false)

  const { bannerHeight } = useBannerContext()

  const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"
  const isFrance = getIsFrance()

  const location = useLocation()

  const options = [
    {
      title: t("plp.navigation.shop_all"),
      link: "/shop-jewelry/",
      childLinks: [
        isFrance ? "/shop-or-jaune-jewelry/" : "/shop-yellow-gold-jewelry/",
        isFrance ? "/shop-or-blanc-jewelry/" : "/shop-white-gold-jewelry/",
        isFrance ? "/shop-or-rose-jewelry/" : "/shop-rose-gold-jewelry/",
      ],
    },
    {
      title: t("plp.navigation.earrings"),
      link: t("link.earrings"),
      childLinks: [
        isFrance ? "/or-jaune-boucles-d-oreilles/" : "/yellow-gold-earrings/",
        isFrance ? "/or-blanc-boucles-d-oreilles/" : "/white-gold-earrings/",
        isFrance ? "/or-rose-boucles-d-oreilles/" : "/rose-gold-earrings/",
        isFrance ? "/or-blanc-creoles/" : "/white-gold-hoops/",
        isFrance ? "/or-jaune-creoles/" : "/yellow-gold-hoops/",
        isFrance ? "/or-rose-creoles/" : "/rose-gold-hoops/",
        isFrance ? "/or-jaune-piercings/" : "/yellow-gold-piercings/",
        isFrance ? "/or-blanc-piercings/" : "/white-gold-piercings/",
        isFrance ? "/or-rose-piercings/" : "/rose-gold-piercings/",
        isFrance ? "/or-jaune-paires/" : "/yellow-gold-pairs/",
        isFrance ? "/or-blanc-paires/" : "/white-gold-pairs/",
        isFrance ? "/or-rose-paires/" : "/rose-gold-pairs/",
        "/yellow-gold-ear-climbers/",
        "/white-gold-ear-climbers/",
        "/rose-gold-ear-climbers/",
        isFrance ? "/or-jaune-ear-cuffs/" : "/yellow-gold-ear-cuffs/",
        isFrance ? "/or-blanc-ear-cuffs/" : "/white-gold-ear-cuffs/",
        isFrance ? "/or-rose-ear-cuffs/" : "/rose-gold-ear-cuffs/",
        "/yellow-gold-statement-earrings/",
        "/white-gold-statement-earrings/",
        "/rose-gold-statement-earrings/",
        t("link.statement_earrings"),
        t("link.ear_cuffs"),
        t("link.ear_climbers"),
        t("link.pairs"),
        t("link.piercings"),
        t("link.hoops"),
      ],
    },
    {
      title: t("plp.navigation.rings"),
      link: t("link.rings"),
      childLinks: [
        isFrance ? "/or-jaune-bagues/" : "/yellow-gold-rings/",
        isFrance ? "/or-blanc-bagues/" : "/white-gold-rings/",
        isFrance ? "/or-rose-bagues/" : "/rose-gold-rings/",
        t("link.statement_rings"),
        "/yellow-gold-statement-rings/",
        "/white-gold-statement-rings/",
        "/rose-gold-statement-rings/",
        t("link.stackable_rings"),
        "/yellow-gold-stackable-rings/",
        "/white-gold-stackable-rings/",
        "/rose-gold-stackable-rings/",
        t("link.pinky_rings"),
        "/yellow-gold-pinky-rings/",
        "/white-gold-pinky-rings/",
        "/rose-gold-pinky-rings/",
        t("link.eternity_rings"),
        "/yellow-gold-eternity-rings/",
        "/white-gold-eternity-rings/",
        "/rose-gold-eternity-rings/",
      ],
    },
    {
      title: t("plp.navigation.necklaces"),
      link: t("link.necklaces"),
      childLinks: [
        isFrance ? "/or-jaune-colliers/" : "/yellow-gold-necklaces/",
        isFrance ? "/or-blanc-colliers/" : "/white-gold-necklaces/",
        isFrance ? "/or-rose-colliers/" : "/rose-gold-necklaces/",

        t("link.personalized_necklaces"),
        isFrance
          ? "/or-jaune-colliers-personnalises/"
          : "/yellow-gold-personalized-necklaces/",
        isFrance
          ? "/or-blanc-colliers-personnalises/"
          : "/white-gold-personalized-necklaces/",
        isFrance
          ? "/or-rose-colliers-personnalises/"
          : "/rose-gold-personalized-necklaces/",
        t("link.statement_necklaces"),
        "/yellow-gold-statement-necklaces/",
        "/white-gold-statement-necklaces/",
        "/rose-gold-statement-necklaces/",
        t("link.solitaire_necklaces"),
        isFrance
          ? "/or-jaune-colliers-solitaire/"
          : "/yellow-gold-solitaire-necklaces/",
        isFrance
          ? "/or-blanc-colliers-solitaire/"
          : "/white-gold-solitaire-necklaces/",
        isFrance
          ? "/or-rose-colliers-solitaire/"
          : "/rose-gold-solitaire-necklaces/",
        t("link.layerable_necklaces"),
        "/yellow-gold-layerable-necklaces/",
        "/white-gold-layerable-necklaces/",
        "/rose-gold-layerable-necklaces/",
      ],
    },
    {
      title: t("plp.navigation.bracelets"),
      link: t("link.bracelets"),
      childLinks: [
        isFrance ? "/or-jaune-bracelets/" : "/yellow-gold-bracelets/",
        isFrance ? "/or-blanc-bracelets/" : "/white-gold-bracelets/",
        isFrance ? "/or-rose-bracelets/" : "/rose-gold-bracelets/",
        t("link.personalized_bracelets"),
        isFrance
          ? "/or-jaune-bracelets-personnalises"
          : "/yellow-gold-personalized-bracelets/",
        isFrance
          ? "/or-blanc-bracelets-personnalises"
          : "/white-gold-personalized-bracelets/",
        isFrance
          ? "/or-rose-bracelets-personnalises"
          : "/rose-gold-personalized-bracelets/",
        t("link.bangle_bracelets"),
        "/yellow-gold-bangle-bracelets/",
        "/white-gold-bangle-bracelets/",
        "/rose-gold-bangle-bracelets/",
        t("link.cord_bracelets"),
        isFrance
          ? "/or-jaune-bracelets-corde/"
          : "/yellow-gold-cord-bracelets/",
        isFrance ? "/or-blanc-bracelets-corde/" : "/white-gold-cord-bracelets/",
        isFrance ? "/or-rose-bracelets-corde/" : "/rose-gold-cord-bracelets/",
        t("link.bracelets_for_him"),
        isFrance
          ? "/or-jaune-bracelets-pour-lui/"
          : "/yellow-gold-bracelets-for-him/",
        isFrance
          ? "/or-blanc-bracelets-pour-lui/"
          : "/white-gold-bracelets-for-him/",
        isFrance
          ? "/or-rose-bracelets-pour-lui/"
          : "/rose-gold-bracelets-for-him/",
      ],
    },
    {
      title: t("plp.navigation.engagement"),
      link: getEngagementPlpLink(),
      childLinks: [
        getEngagementPlpLink("yellow gold"),
        getEngagementPlpLink("white gold"),
        getEngagementPlpLink("rose gold"),
      ],
    },
    {
      title: t("plp.navigation.wedding_bands"),
      link: getWeddingLink(),
      childLinks: [
        isFrance ? "/alliances-pour-lui/" : "/wedding-bands-for-him/",
      ],
    },
    { title: t("plp.navigation.bespoke_service"), link: getBespokeLink() },
  ]

  const pathname =
    activeEnv === "us"
      ? location.pathname
      : location.pathname.replace(`/${activeEnv}/`, "/")
  return (
    <>
      <MobileFilter $bannerH={bannerHeight}>
        <Filter
          onClick={() => setCategoryOpen(!categoryOpen)}
          $open={categoryOpen ? 1 : 0}
        >
          {t("plp.filter.category")}
          <Icon $open={categoryOpen ? 1 : 0}>
            <span />
            <span />
          </Icon>
          <CategoryOptions $open={categoryOpen ? 1 : 0}>
            <ul>
              {options.map((category, index) => {
                const active =
                  category?.link?.includes(pathname) ||
                  category.childLinks?.includes(pathname)
                return (
                  <LinkContainer key={index} $isActive={active ? 1 : 0}>
                    <Link to={category.link}>{category.title}</Link>
                  </LinkContainer>
                )
              })}
            </ul>
          </CategoryOptions>
        </Filter>
        <Filter onClick={() => setSortOpen(!sortOpen)}>
          {t("plp.filter.sort")}
          <Icon $open={sortOpen ? 1 : 0}>
            <span />
            <span />
          </Icon>
        </Filter>
      </MobileFilter>
      <FilterOverlay
        $open={sortOpen}
        handleOverlay={setSortOpen}
        filterOptions={filterOptions}
        applyFilter={applyFilter}
        setSort={setSort}
        colours={colours}
        sort={sort}
        types={types}
        price={price}
        styles={styles}
        handleColour={handleColour}
        handlePrice={handlePrice}
        handleTypeFilter={handleTypeFilter}
        handleStyle={handleStyle}
        clearFilter={clearFilter}
      />
    </>
  )
}

export default withTranslation()(MobileFilters)


